/*
  lp-affiliate: sticky apply bar (mobile). Shows the bar once the hero apply button has scrolled
  above the viewport, and hides it while the final CTA band is on screen. No dependencies.
  Without IntersectionObserver or without JS the bar simply stays hidden.
*/
(function () {
  var bar = document.querySelector('[data-lpa-sticky]');
  var hero = document.querySelector('[data-lpa-hero-cta]');
  var final = document.querySelector('[data-lpa-final]');
  if (!bar || !hero || !('IntersectionObserver' in window)) return;

  var heroPassed = false;
  var finalVisible = false;

  function update() {
    var show = heroPassed && !finalVisible;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      bar.removeAttribute('inert');
    } else {
      bar.setAttribute('inert', '');
    }
  }

  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      heroPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    });
    update();
  }).observe(hero);

  if (final) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        finalVisible = entry.isIntersecting;
      });
      update();
    }).observe(final);
  }
})();
